import { render, staticRenderFns } from "./ResourceListItem.vue?vue&type=template&id=0f68aad3"
import script from "./ResourceListItem.vue?vue&type=script&lang=js"
export * from "./ResourceListItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceListItem.vue?vue&type=style&index=0&id=0f68aad3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports